/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import PageScroll from "./modules/PageScroll";
import Tabs from "./modules/Tabs";
import Accordion from "./modules/Accordion";
import MapLoader from "./modules/MapLoader";
import CustomSelect from "./modules/CustomSelect";
import ToggleNav from "./modules/ToggleNav";
import SearchCityComponent from "./modules/SearchCityComponent";
import StickNavbar from "./modules/StickNavbar";
import NewsSlider from "./modules/NewsSlider";
import BusinessSlider from "./modules/BusinessSlider";
import ArchivesTabs from "./modules/ArchivesTabs";
// import DatePicker from "./modules/DatePicker";
import PostsFilter from "./modules/PostsFilter";
import ContactForm from "./modules/ContactForm";
import Glossary from "./modules/Glossary";
import Faq from "./modules/Faq";
import ChangeViewsNumber from "./modules/ChangeViewsNumber";
import DetectGlossary from "./modules/DetectGlossary";
import SocialMediaSwitch from "./modules/SocialMediaSwitch";
import GeneratePdf from "./modules/GeneratePdf";
import ShareButton from "./modules/ShareButton";
import Tutorial from "./modules/Tutorial";
import AddAds from "./modules/AddAds";
import NewsByTagSlider from './modules/NewsByTagSlider'


/**
 * Instantiate a new object using imported modules/classes
 */





window.document.addEventListener("DOMContentLoaded", ()=>{
    const socialSwitch = new SocialMediaSwitch();
    const postFilter = new PostsFilter();
    const shareButton = new ShareButton();
    const toggleNav = new ToggleNav();


})

window.addEventListener("load", () => {
    const myTabs = new Tabs("jsInfoTabs");
    const selectLang = new CustomSelect("jsSelectLang", false);
    const defaultSelect = new CustomSelect("defaultSelectJs", false);
    const selectCategory = new CustomSelect("selectCatJs", false);
    const subjectSelect = new CustomSelect("jsSubjectSelect", false);

    const infoAccordions = Array.from(document.querySelectorAll(".jsInfoAccordion"));

    const stickNavbar = new StickNavbar();
    if (infoAccordions.length) {
        infoAccordions.forEach((infoAccordion) => new Accordion(infoAccordion));
    }
    const newSlider = new NewsSlider();
    const businessSlider = new BusinessSlider();
    const newsByTagSlider = new NewsByTagSlider();
    const archivesTabs = new ArchivesTabs('jsPostFilter');
    const socialMediaSwitch = new ArchivesTabs('jsSocialSwitch');

    const contactForm = new ContactForm();
    const glossary = new Glossary();
    const faqAccordion = new Faq();
    const changeViewsNumber = new ChangeViewsNumber();
    const detectGlossary = new DetectGlossary();

    const generatePDF = new GeneratePdf();
    // const searchCityComponent = new SearchCityComponent();
    const tutorial = new Tutorial();
    const adAds = new AddAds();
    
});